'use client';

import pluralize from '@/lib/utils/pluralize';
import Image from 'next/image';

type Props = {
  technology: Technology
}

interface ToggleClickEvent extends React.MouseEvent<HTMLDivElement> {
  currentTarget: HTMLDivElement & EventTarget;
}

export default function Item ({ technology }: Props): JSX.Element {
  const { name, yearsOfExperience, fileName } = technology;
  const yearStr: string = pluralize(yearsOfExperience || 1, 'year', 'years')
  const imageClassNames = 'max-h-12 inline-block object-contain';


  const toggleClick = (event: ToggleClickEvent): void => {
    const isActive = event.currentTarget.classList.contains('active');
    const activeElements = event.currentTarget.parentElement?.querySelectorAll('.active ');
    activeElements?.forEach((element) => element.classList.remove('active'));
    isActive ? event.currentTarget.classList.remove('active') : event.currentTarget.classList.add('active');
  };

  return (
    <div className="technology-item" onClick={toggleClick}>
      <div className="foreground">
        <Image src={`${process.env.NEXT_PUBLIC_AWS_S3_BUCKET_URL}/technologies/${fileName}`} alt={name} className={imageClassNames} width={100} height={100} />
      </div>
      <div className="background">
        <Image src={`${process.env.NEXT_PUBLIC_AWS_S3_BUCKET_URL}/technologies/${technology.fileName}`} alt={technology.name} className={imageClassNames} width={100} height={100} />
        <div className="mt-4">{technology.name}</div>
        <div>{`${yearsOfExperience} ${yearStr}`}</div>
      </div>
    </div>
  )
}
